import { type FC, type ReactNode } from 'react';

import { stopPropagation } from '@/packages/utils/event/stopPropagation';

import styles from './VASBlock.css';

type VASBlockProps = {
  publicationDate: ReactNode;
  vasList: ReactNode;
  isAgentUser: boolean;
  isNarrow: boolean;
};

export const VASBlock: FC<VASBlockProps> = props => {
  const { isAgentUser, isNarrow, publicationDate, vasList } = props;

  if (isNarrow) {
    return (
      <div className={styles['container-short-listing']}>
        <div className={styles['pub-date-container']}>{publicationDate}</div>
        {isAgentUser && <div className={styles['vas']}>{vasList}</div>}
      </div>
    );
  }

  return (
    <div className={styles['container']} onClick={stopPropagation}>
      {publicationDate}
      {isAgentUser && vasList}
    </div>
  );
};
